import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    lobbyMachines: {},
 };

export const lobbyMachinesSlice = createSlice({
    name: 'lobbyMachines',
    initialState,
    reducers: {
        setLobbyMachines(state, action) {
            state.lobbyMachines = action.payload;
        },
    }
});

export default lobbyMachinesSlice;